import { TrackerStatus } from './trackerstatus.entity';
import { Retailer } from './retailer.entity';
import { SimBrand } from './sim-brand.entity';
export class TrackerAdmin {
  id: number;

  type: string;

  msisdn: string;

  firmware: string;

  imei: number;

  sim: string;
  sim_brand: SimBrand;

  status: TrackerStatus;
  status_id: number;

  retailer: Retailer = new Retailer();
  retailer_id: number;

  signature_pkey: string;

  need_upgrade: boolean;

  location_code: string;
  lot: string;
  model: string;
  tracker_color: string;
}



// WEBPACK FOOTER //
// /app/src/app/entities/trackeradmin.entity.ts